import React from 'react';
import { Box, Button } from '@mui/material';
import { useThemeMode } from '../theme/ThemeModeContext';

const ThemeModeToggle = ({ sx }) => {
  const { mode, setMode } = useThemeMode();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.25,
        border: '1px solid var(--oc-ink-08)',
        borderRadius: 100,
        overflow: 'hidden',
        fontSize: '0.75rem',
        fontWeight: 600,
        ...sx
      }}
      role="group"
      aria-label="Fargetema"
    >
      <Button
        size="small"
        onClick={() => setMode('light')}
        sx={{
          minWidth: 48,
          borderRadius: 0,
          py: 0.5,
          px: 1.5,
          color: mode === 'light' ? 'primary.contrastText' : 'text.secondary',
          bgcolor: mode === 'light' ? 'primary.main' : 'transparent',
          '&:hover': { bgcolor: mode === 'light' ? 'primary.dark' : 'var(--oc-ink-06)' }
        }}
      >
        Lys
      </Button>
      <Button
        size="small"
        onClick={() => setMode('dark')}
        sx={{
          minWidth: 48,
          borderRadius: 0,
          py: 0.5,
          px: 1.5,
          color: mode === 'dark' ? 'primary.contrastText' : 'text.secondary',
          bgcolor: mode === 'dark' ? 'primary.main' : 'transparent',
          '&:hover': { bgcolor: mode === 'dark' ? 'primary.dark' : 'var(--oc-ink-06)' }
        }}
      >
        Mørk
      </Button>
    </Box>
  );
};

export default ThemeModeToggle;
